<md-tag class="status-40x">
	<span>404 Error</span>
</md-tag>

<div class="message-40x">
	<div class="md-display-lg-semibold">Page Not Found...</div>
	<div class="md-text-md-regular">Sorry! We can't find the page you're looking for...</div>
</div>

<div class="actions-40x">
	<a href="#" onclick="history.back(); return false;" md-button>Go Back</a>
	<a href="/" md-button-brand>Go Home</a>
</div>
